/** Initialise smarty data layer object in tests */
export const initialiseSmartyDataLayer = () => {
  window.smDl = {
    events: [],
  }
}
